import { Button, type ButtonProps } from '@lemonade-hq/nuis';
import { COLORS } from '@lemonade-hq/tokens';
import type React from 'react';
import styled from 'styled-components';
import { shareOnTwitter } from '../../utils/sharing';

export function share(text: string, url: string): void {
  shareOnTwitter(text, url);
}

// TODO: monolu
export function supportsNativeShare(): boolean {
  return window.navigator != null && window.navigator.share != null;
}

export async function shareNatively(title?: string, text?: string, url?: string): Promise<void> {
  if (supportsNativeShare()) {
    // biome-ignore lint/style/noNonNullAssertion: <explanation>
    return window.navigator.share!({ title, text, url });
  }
}

export async function globalShare(
  nativeSharingEnabled: boolean,
  title?: string,
  text?: string,
  url?: string,
): Promise<void> {
  return nativeSharingEnabled && supportsNativeShare() ? shareNatively(title, text, url) : share(text ?? '', url ?? '');
}

const ShareButton = styled(Button)`
  padding: 0 15px;
  height: 40px;

  &:hover {
    color: ${COLORS.white};
    background-color: ${COLORS.pink};
    transition: all 0.3s ease-out;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    margin-top: 5px;
  }
`;

interface ShareGivebackButtonProps extends Omit<ButtonProps, 'hugging'> {
  event: string;
  content: string;
  title?: string;
  url: string;
  nativeSharing?: boolean;
  text?: string;
}

const ShareGivebackButton: React.FC<ShareGivebackButtonProps> = ({
  event,
  content,
  title,
  url,
  flavor,
  nativeSharing = false,
  text = 'SHARE',
  ...props
}) => {
  return (
    <ShareButton
      {...props}
      minWidth={90}
      hugging={false}
      flavor={flavor ?? 'ghost'}
      onClick={() => globalShare(nativeSharing, title, content, url)}
      data-event={event}
    >
      {text}
    </ShareButton>
  );
};

export default ShareGivebackButton;
